<template>
 <div>
    <el-dialog  title="个性化配置"  :close-on-click-modal="false" :close-on-press-escape="false"
     @close="closeDialog"   :visible.sync="GXHdialog" width="1000px" center>
      <span>
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="1">开通前配置</el-menu-item>
          <el-menu-item index="2" v-if="rowData.openTenantFlag==1">开通后配置</el-menu-item>
        </el-menu>
        <ul class="box" v-if="shuxingList.length>0">
          <li class="boxItem" v-for="item in shuxingList" :key="item.attributeFlag">
              <el-tooltip class="item" effect="dark" :content="item.attributeRemark" placement="top-start">
                <span>
                  <i class="fa fa-question-circle-o" aria-hidden="true"></i>
                  <span class="title">{{item.attributeName}}</span>
                </span>
              </el-tooltip>
              <el-radio-group v-model="item.attributeDefault" v-if="item.attributeType==2">
                  <el-radio   v-for="item in item.optionsList"   :key="item.optionValue" :label="item.optionValue">{{ item.optionName}}</el-radio>
              </el-radio-group>
              <el-checkbox-group v-model="item.attributeArr" v-if="item.attributeType==3" >
                <el-checkbox
                  v-for="item in item.optionsList"
                  :key="item.optionValue"
                  :label="item.optionValue"
                  >{{ item.optionName }}</el-checkbox>
                </el-checkbox-group>
              <el-input style="width: 430px" v-if="item.attributeType==1"  maxlength="100"  type="textarea" v-model="item.attributeDefault"></el-input>
          </li>
        </ul>
        <p v-else style="text-align: center;">暂无数据</p>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button  @click="GXHdialog = false">取消</el-button>
        <el-button type="primary" @click="GXHsave('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { sAttributeObjRelList, sAttributeObjRelAdd } from '@/api/newCrm'
export default {
  name: 'shenheJilu',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      GXHdialog: false,
      GXHfrom: {},
      activeIndex: '1',
      shuxingList: [],
      customerdata: {
        targetType: 3, // '目标对象类型(1.用户，2.租户，3.客户)',
        tenantCode: this.rowData.tenantCode,
        useTenantCode: this.rowData.tenantCode,
        sceneIdList: [1],
        targetCode: this.rowData.custerCode,
        rId: this.rowData.rId
      },
      tenantdata: {
        targetType: 2, // '目标对象类型(1.用户，2.租户，3.客户)',
        tenantCode: this.rowData.tenantCodeH,
        useTenantCode: this.rowData.code,
        sceneIdList: [2],
        targetCode: this.rowData.code,
        rId: this.rowData.rId
      }
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.getList(this.customerdata)
    this.GXHdialog = true
  },
  methods: {
    handleSelect (index) {
      if (index == 1) {
        this.activeIndex = '1'
        this.getList(this.customerdata)
      } else {
        this.activeIndex = '2'
        this.getList(this.tenantdata)
      }
    },
    getList (data) { // 1租户开通客户，2租户开通客户，3租户添加自有用户，4租户添加客户用户
      sAttributeObjRelList(data).then(res => {
        this.shuxingList = res
        this.shuxingList.forEach((item, index) => {
          if (item.attributeType == 3 && item.attributeDefault) {
            this.$set(this.shuxingList[index], 'attributeArr', item.attributeDefault.split(','))
          } else {
            this.$set(this.shuxingList[index], 'attributeArr', [])
          }
        })
      }).catch(error => {
        this.shuxingList = []
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    // getList1 () {
    //   sAttributeObjRelList({
    //     targetType: 2, // '目标对象类型(1.用户，2.租户，3.客户)',
    //     tenantCode: this.rowData.tenantCode,
    //     useTenantCode: this.rowData.code,
    //     sceneIdList: [2],
    //     targetCode: this.rowData.tenantCode,
    //     rId: this.rowData.rId
    //   }).then(res => {
    //     this.shuxingList = res
    //   })
    // },
    GXHsave () {
      let data = null
      if (this.activeIndex == 1) {
        data = this.customerdata
      } else {
        data = this.tenantdata
      }
      this.shuxingList.forEach((item, index) => {
        if (item.attributeType == 3) {
          this.$set(this.shuxingList[index], 'attributeDefault', item.attributeArr.toString())
        }
      })
      data.attributeList = this.shuxingList
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      sAttributeObjRelAdd(data).then(res => {
        this.shuxingList = res
        this.$emit('destroy')
        loading.close()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialog () {
      this.$emit('destroy')
    }
  }

}
</script>

<style scoped lang='less'>
.box{
  font-size: 14px;
  padding: 10px 20px;
  .boxItem{
    display: flex;
    align-items: center;
    .title{
      display: inline-block;
      // width: 200px;
    }
    margin-bottom: 20px;
  }
  /deep/.el-tooltip{
      flex-shrink: 0;
      width: 30%;
      margin-right: 30px;
    }
  .fa{
    font-size: 18px;
    color:#0B4FD6 ;
    margin-right: 8px;
  }
}
/deep/.el-dialog .el-dialog__body{
  padding: 0;
}
/deep/.el-menu--horizontal>.el-menu-item{
  height: 50px;
  line-height: 50px;
}

</style>
